/* eslint-disable */
import { FILTER_TODAY_DATE_SELECTED } from '../Filters.types';

/**
 * Action to update the `startDate` in the filters to today's date
 * @returns {ActionCreator<FromPayload<null, ActionMeta, FILTER_TODAY_DATE_SELECTED>>} The created `Action`
 */
const filtersTodayDateSelected = () => ({ fromPayload }) => {
  return fromPayload(null, { debounce: true }, FILTER_TODAY_DATE_SELECTED);
};

export default filtersTodayDateSelected;
